import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form"]

  connect() {
    if(window.location.href.includes("/admin/np_calculation_rules/") && window.location.href.includes("/edit")) {
      this.getCustomersKyc().then(r => {
        const products = document.getElementsByName("np_calculation_rule[product_id][]");
        const percentages_of_products = document.getElementsByName("np_calculation_rule[percentage_of_product]");
        let count = 0;
        products.forEach((product, index) => {
          if (r[0].includes(product.value)) {
            product.checked = true;
            percentages_of_products[index].value = r[1][count];
            count += 1;
          }
        });
      });
    } else {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const percentages_of_products = document.getElementsByName("np_calculation_rule[percentage_of_product]");
      const products = document.getElementsByName("np_calculation_rule[product_id][]");
      const params = {};

      for (const [key, value] of urlParams) {
        params[key] = value;
      }
      let hashProducts = JSON.parse(params["np_calculation_rule[products]"]);
      products.forEach((product, index) => {
        if (hashProducts[product.value] !== undefined) {
          product.checked = true;
          percentages_of_products[index].value = hashProducts[product.value];
        }
      });
    }
  }

  async getCustomersKyc() {
    const url = window.location.href;
    const id = url.split("/")[5];
    return await fetch(`/admin/np_calculation_rules/products_keys.json?id=${id}`).then(response => response.json());
  }

  submit(event) {
    event.preventDefault();
    const startAmount = parseFloat(document.getElementById("np_calculation_rule_start_amount").value);
    const endAmount = parseFloat(document.getElementById("np_calculation_rule_end_amount").value);
    let form = document.querySelector("#new_np_calculation_rule");
    const products = document.getElementsByName("np_calculation_rule[product_id][]");
    if (window.location.href.includes("/edit")) {
      form = document.getElementsByClassName("edit_np_calculation_rule")[0];
    }
    const jsonbProducts = document.getElementById("np_calculation_rule_products");
    let countDifferentProducts = 0;
    let countDifferentPercentages = 0;
    let checkedAmount = false;
    let checkedPercentage = false;
    let checkAmount;
    let checkPercentage;
    let sum = 0;
    const percentages_of_products = document.getElementsByName("np_calculation_rule[percentage_of_product]");
    percentages_of_products.forEach((percentage, index) => {
      if (!isNaN(parseFloat(percentage.value))) {
        sum += parseFloat(percentage.value);
      }
      if (!isNaN(parseFloat(percentage.value)) && parseFloat(percentage.value) > 0 && products[index].checked === false) {
        countDifferentProducts += 1;
      } else if (isNaN(parseFloat(percentage.value)) && products[index].checked === true) {
        countDifferentPercentages += 1;
      }
    });
    if (countDifferentProducts === 0 && countDifferentPercentages === 0) {
      checkAmount = this.validationForAmount(startAmount, percentages_of_products, products);
      checkedAmount = checkAmount === 0;
    }
    if (checkAmount === 1) {
      checkPercentage = this.validationPercentageCombination(startAmount, percentages_of_products, products);
      checkedPercentage = checkPercentage !== "Correct";
    }
    if (this.invalidInputs() > 0 || sum !== 100.0 || countDifferentProducts > 0 || startAmount >= endAmount || startAmount < 3000 || countDifferentPercentages > 0 || checkedAmount || checkedPercentage) {
      this.scrollToTop();
      let errorText;
      if (this.invalidInputs() > 0) {
        errorText = "Bitte Pflichtfelder ausfüllen";
      } else if (startAmount < 3000.0) {
        errorText = "Der Startbetrag sollte mehr als 3000 betragen";
      } else if (startAmount >= endAmount) {
        errorText = "Der Startbetrag sollte kleiner als der Endbetrag sein";
      } else if (sum !== 100.0) {
        errorText = "Sie müssen Prozentsätze für einen Betrag von 100 eingeben";
      } else if (checkedAmount) {
        errorText = "Es ist unmöglich, ein np-Paket mit der Kombination dieser Produktprozentsätze zu erstellen";
      } else if (checkedPercentage) {
        errorText = "Für die eingegebenen Parameter ist der Provisionsprozentsatz => " + checkPercentage.toFixed(2) + " %";
      } else if (countDifferentProducts > 0 || countDifferentPercentages > 0) {
        errorText = "Sie sollten Produkte an Ort und Stelle überprüfen, wo Sie Prozentsätze eingeben";
      }
      let parentElement = document.getElementById("for_error");
      this.alertMessage(parentElement, errorText);
      jsonbProducts.value = this.jsonbValues(form);
      return 0;
    } else {
      document.getElementById("np_rule_alert").classList.add("d-none");
      jsonbProducts.value = this.jsonbValues(form);
      form.submit();
    }
  }

  enableSubmitButton() {
    document.getElementById("submitButton").disabled = false;
  }

  jsonbValues(form) {
    const formData = new FormData(form);
    const products = formData.getAll("np_calculation_rule[product_id][]").toString().split(",");
    const percentages_of_products = formData.getAll("np_calculation_rule[percentage_of_product]").toString().split(",").filter(Boolean);
    let jsonString = {};
    products.forEach(function(el, index) {
      let newElement = { [el]: percentages_of_products[index] };
      Object.assign(jsonString, newElement);
    });
    return JSON.stringify(jsonString);
  }

  validationPercentageCombination(startAmount, percentages_of_products, products) {
    if(startAmount === "") {
      return 2;
    } else {
      let percentage = 0;
      let hashProductsWithCommission = {};
      let hashProductsWithoutCommission = {};
      let count = 0;
      let numberOfProduct = 0;
      let priceWithCommission = 0;
      let priceWithoutCommission = 0;
      percentages_of_products.forEach((percentage, index) => {
        priceWithCommission = parseFloat(percentage.getAttribute("data-priceWithCommission"));
        priceWithoutCommission = parseFloat(percentage.getAttribute("data-priceWithoutCommission"));
        if (!isNaN(parseFloat(percentage.value)) && products[index].checked === true) {
          if(count === 0) {
            numberOfProduct = Math.round(((startAmount * percentage.value) / 100) / priceWithCommission);
          } else {
            numberOfProduct = parseInt(((startAmount * percentage.value) / 100) / priceWithCommission);
          }
          hashProductsWithCommission[`${numberOfProduct}`] = priceWithCommission;
          hashProductsWithoutCommission[`${numberOfProduct}`] = priceWithoutCommission;
        }
      });
      let resultWithCommission = 0;
      let resultWithoutCommission = 0;
      for (let key in hashProductsWithCommission) {
        resultWithCommission += (parseInt(key) * hashProductsWithCommission[key]);
        resultWithoutCommission += (parseInt(key) * hashProductsWithoutCommission[key]);
      }
      percentage = ((resultWithCommission - resultWithoutCommission) / resultWithoutCommission) * 100;
      if (percentage >= 7.56 && percentage <= 8.00) {
        return "Correct";
      } else {
        return percentage;
      }
    }
  }

  validationForAmount(startAmount, percentages_of_products, products) {
    if(startAmount === "") {
      return 2;
    } else {
      let sum = 0;
      let count = 0;
      let numberOfProduct = 0;
      let priceWithCommission = 0;
      percentages_of_products.forEach((percentage, index) => {
        priceWithCommission = parseFloat(percentage.getAttribute("data-priceWithCommission"));
        if (!isNaN(parseFloat(percentage.value)) && products[index].checked === true) {
          if(count === 0) {
            numberOfProduct = Math.round(((startAmount * percentage.value) / 100) / priceWithCommission);
          } else {
            numberOfProduct = parseInt(((startAmount * percentage.value) / 100) / priceWithCommission);
          }
          sum += numberOfProduct * priceWithCommission;
          count += 1;
        }
      });
      let percentageOfStartAmount = ((startAmount * 105) / 100) - startAmount;
      if (startAmount > 10000) {
        percentageOfStartAmount = ((startAmount * 101) / 100) - startAmount;
      }
      if (sum >= startAmount - percentageOfStartAmount && sum <= startAmount + percentageOfStartAmount) {
        return 1;
      } else {
        return 0;
      }
    }
  }

  alertMessage(parentElement, errorText) {
    const textErrorMessage = document.getElementById("np_rule_alert");
    textErrorMessage.classList.remove("d-none");
    textErrorMessage.innerText = errorText;
  }

  invalidInputs() {
    const invalidFields = [];
    document.querySelectorAll("input.required, checkbox.required, textarea.required, select.required, div.form-group.upload.required button").forEach(function (item) {
      if (item.offsetParent !== null && item.value.trim() === "" || item.type === "checkbox" && item.checked === false && item.nextSibling && item.nextSibling.offsetParent !== null) {
        item.classList.add("is-invalid");
        invalidFields.push(item);
      } else {
        item.classList.remove("is-invalid");
      }
    });
    return invalidFields.length;
  }

  scrollToTop() {
    let container = $(".wrapper.full").length ? $(".wrapper.full") : $([document.documentElement, document.body]);
    container.scrollTop(0);
  }

  showPercentage() {
    const startAmount = parseFloat(document.getElementById("np_calculation_rule_start_amount").value);
    const percentages_of_products = document.getElementsByName("np_calculation_rule[percentage_of_product]");
    const products = document.getElementsByName("np_calculation_rule[product_id][]");
    const divForPercentage = document.getElementById("for_percentage");
    let WithCommission = 0;
    let numberProduct = 0;
    let sumValue = 0;
    let count = 0;
    let percentageOfStartAmount = parseFloat(((startAmount * 105) / 100) - startAmount);
    if (startAmount > 10000) {
      percentageOfStartAmount = parseFloat(((startAmount * 101) / 100) - startAmount);
    }
    percentages_of_products.forEach((percentage, index) => {
      WithCommission = parseFloat(percentage.getAttribute("data-priceWithCommission"));
      if (!isNaN(parseFloat(percentage.value)) && products[index].checked === true) {
        if(count === 0) {
          numberProduct = Math.round(((startAmount * percentage.value) / 100) / WithCommission);
        } else {
          numberProduct = parseInt(((startAmount * percentage.value) / 100) / WithCommission);
        }
        sumValue += numberProduct * WithCommission;
        count += 1;
      }
    });
    let percentage = this.validationPercentageCombination(startAmount, percentages_of_products, products);
    if (percentage === "Correct" && (sumValue >= startAmount - percentageOfStartAmount && sumValue <= startAmount + percentageOfStartAmount)) {
      divForPercentage.classList.remove("alert-danger");
      divForPercentage.classList.add("alert-success");
      divForPercentage.querySelector("h3").innerText = `Gesamtbetrag und Aufschlag sind korrekt.\nDer Gesamtbetrag (brutto) der Betragsbereich beginnt mit € ${sumValue.toFixed(2)}`;
      divForPercentage.classList.remove("d-none");
    } else {
      divForPercentage.classList.remove("alert-notice");
      divForPercentage.classList.add("alert-danger");
      if (isNaN(percentage.toFixed(2))) {
        divForPercentage.querySelector("h3").innerText = "Gesamtbetrag oder Aufschlag ist falsch!";
      } else {
        let correctPercentage = `${percentage.toFixed(2)} %`;
        if (percentage === "Correct") {
          correctPercentage = "Prozent stimmt!";
        }
        divForPercentage.querySelector("h3").innerText = `Gesamtbetrag oder Aufschlag ist falsch!\nAufschlag: ${correctPercentage}\nDer Gesamtbetrag (brutto) der Betragsbereich beginnt mit € ${sumValue.toFixed(2)}`;
      }
      divForPercentage.classList.remove("d-none");
    }
  }
}
